import Coin3D from './Coin3D';

export default function SpinningLogo({ size = 40, className = '', gold = true, imageUrl }) {
  return (
    <div className={`spinning-logo ${className}`} style={{ width: size, height: size }}>
      <Coin3D size={size} gold={gold} imageUrl={imageUrl} />
    </div>
  );
}
